import { execFileSync } from 'node:child_process';
import * as path from 'node:path';

/**
 * Best-effort git repo root for `startDir` (e.g. monorepo root when cwd is a package).
 */
export function getGitRepoRootSync(startDir: string): string | null {
  try {
    const out = execFileSync('git', ['rev-parse', '--show-toplevel'], {
      cwd: path.resolve(startDir),
      encoding: 'utf8',
      stdio: ['ignore', 'pipe', 'ignore'],
      maxBuffer: 1024 * 1024,
    }).trim();
    return out ? path.resolve(out) : null;
  } catch {
    return null;
  }
}
